import { getFilterValue } from '../utils/tool';
import axios from 'axios';
import { request } from '../common/request';
export const SceneDataProcessingMixin = {
  methods: {
    /**
     * 处理图表数据并返回处理后的结果
     * @param {Object} chartData - 要发送的数据对象
     * @returns {Promise<Object>} 处理后的数据对象
     */
    processChartData(chartData) {
      return new Promise(resolve => {
        // 等待DOM更新完成
        this.$nextTick(() => {
          const responseData = {
            datas: [
              {
                name: chartData.SceneName + '数据统计',
                children: [],
              },
            ],
            prompt: chartData.SceneDesc,
            is_summarize: true,
          };
          chartData.Charts.forEach(item => {
            console.log(item, 'vxxvzdvxvx');

            // 使用 staticData 静态数据
            if (item?.propertyData?.ChartsData?.value?.currenEntry == 'staticData') {
              responseData.datas[0].children.push({
                name:
                  item.propertyData.titleText.value == '图表标题'
                    ? item.propertyData.ChartsData.value.staticData.seriesList[0]
                    : item.propertyData.titleText.value,
                children: item.propertyData.ChartsData.value.staticData.source || [],
              });
            } else if (item?.propertyData?.ChartsData?.value?.currenEntry == 'apiData') {
              let apidata = item.propertyData.ChartsData.value.apiData;
              // API 地址
              let apiUrl = apidata.apiUrl;

              // 参数 处理
              let apiPostParams = apidata.apiPostParams || '{}';
              window.getFilterValue = getFilterValue;
              const paramRegex = /that\.getFilterValue\(['"]([^'"]+)['"]\)/g;
              const executableStr = apiPostParams.replace(paramRegex, (match, key) => {
                return `window.getFilterValue('${key}')`;
              });
              const finalStr = executableStr;
              const parsedParams = eval(`(${finalStr})`);

              let param = {
                method: 'get',
                url: apiUrl,
                params: parsedParams,
                headers: { 'Content-Type': 'application/json' },
              };
              request(param).then(res => {
                if (res.data) {
                  responseData.datas[0].children.push({
                    name: item.propertyData.titleText.value,
                    children: res.data || [],
                  });
                }
              });
            }
          });
          // 返回处理好的数据
          resolve(responseData);
        });
      });
    },
  },
};

export default SceneDataProcessingMixin;
